/** Workflow konstanty */
export const CONST_WORKFLOW_EL = "Workflow";
export const CONST_WORKFLOW_DEFINITION_VERSION_AT = "DefinitionVersion";
export const CONST_WORKFLOW_VERSION_AT = "version";
export const CONST_WORKFLOW_CLASS_NAME_AT = "className";
export const CONST_WORKFLOW_IDENTIFIER_AT = "identifier";

/** Set konstanty */
export const CONST_SET_EL = "Set";
export const CONST_SET_DEFINITIONS_EL = "SetDefinitions";
export const CONST_SET_NAME_AT = "name";
export const CONST_SET_DESCRIPTION_AT = "description";

/** Activity konstanty */
export const CONST_ACTIVITY_EL = "Activity";
export const CONST_ACTIVITY_ID_AT = "id";
export const CONST_ACTIVITY_CONDITION_AT = "condition";
export const CONST_ACTIVITY_RUN_CONDITION_AT = "runCondition";
export const CONST_ACTIVITY_NAME_AT = "name";
export const CONST_ACTIVITY_TYPE_AT = "type";
export const CONST_ACTIVITY_ORDER_AT = "order";
export const CONST_ACTIVITY_KILL_CHILDREN_AT = "killChildren";
export const CONST_ACTIVITY_SHOW_IN_WF_HISTORY_AT = "showInWFHistory";
export const CONST_ACTIVITY_INHERIT_PARTICIPANTS_AT = "inheritParticipants";
export const CONST_ACTIVITY_INPUT_TRANS_TYPE_AT = "inputTransType";
export const CONST_ACTIVITY_DESCRIPTION_AT = "description";
export const CONST_START_ACTIVITY_EL = "StartActivity";
export const CONST_END_ACTIVITY_EL = "EndActivity";

/** Transition konstanty */
export const CONST_TRANSITIONS_EL = "Transitions";
export const CONST_TRANSITION_EL = "Transition";
export const CONST_TRANSITION_ID_AT = "id";
export const CONST_TRANSITION_NAME_AT = "name";
export const CONST_TRANSITION_TO_AT = "to";
export const CONST_TRANSITION_CONDITION_AT = "condition";
export const CONST_DRAW_EL = "Draw";
export const CONST_DRAW_SET_AT = "set";
export const CONST_POINT_EL = "Point";
export const CONST_POINT_X_AT = "x";
export const CONST_POINT_Y_AT = "y";

/** Actions konstanty */
export const CONST_ACTIONS_EL = "Actions";
export const CONST_ACTION_COMMENT_AT = "comment";
export const CONST_ACTION_CONDITION_AT = "condition";
export const CONST_CALL_METHOD_EL = "CallMethod";
export const CONST_CALL_METHOD_METHOD_NAME_AT = "methodName";
export const CONST_CALL_METHOD_STATIC_AT = "static";
export const CONST_CALL_METHOD_INSERT_ACTUAL_OBJECT_AT = "insertActualObject";
export const CONST_CALL_METHOD_INSERT_PARAM_FORM_OBJECT_AT = "insertParamFormObject";
export const CONST_CALL_METHOD_DEFAULT_PARAM_VALUE_AT = "defaultParamValue";
export const CONST_CALL_SCRIPT_EL = "CallScript";
export const CONST_CALL_SCRIPT_SCRIPT_AT = "script";
export const CONST_INCREMENT_DATE_TIME_EL = "IncrementDateTime";
export const CONST_INCREMENT_DATE_TIME_ATTR_NAME_AT = "attrName";
export const CONST_INCREMENT_DATE_TIME_VALUE_AT = "value";
export const CONST_INCREMENT_DATE_TIME_PRECISION_AT = "precision";
export const CONST_INCREMENT_NUMBER_EL = "IncrementNumber";
export const CONST_INCREMENT_NUMBER_ATTR_NAME_AT = "attrName";
export const CONST_INCREMENT_NUMBER_VALUE_AT = "value";
export const CONST_MESSAGE_RECIPIENT_EL = "MessageRecipient";
export const CONST_SEND_CALENDAR_EL = "SendCalendar";
export const CONST_SEND_MAIL_EL = "SendMail";
export const CONST_SEND_MAIL_RECIPIENT_AT = "recipient";
export const CONST_SEND_MAIL_SUBJECT_AT = "subject";
export const CONST_SEND_MAIL_TEXT_AT = "text";
export const CONST_SEND_MAIL_CLASS_NAME_AT = "className";
export const CONST_SEND_MAIL_ATTR_NAME_AT = "attrName";
export const CONST_SEND_MAIL_DATA_CONDITION_AT = "dataCondition";
export const CONST_SEND_MAIL_REPORT_TEMPLATE_AT = "reportTemplate";
export const CONST_SEND_MAIL_SUMMARY_MAIL_AT = "summaryMail";
export const CONST_SEND_MAIL_FORMAT_AT = "format";
export const CONST_SEND_MAIL_DOCUMENT_CLASS_NAME_AT = "documentClassName";
export const CONST_SEND_MAIL_DOCUMENT_ATTRIBUTE_AT = "documentAttribute";
export const CONST_SEND_MAIL_DOCUMENT_CONDITION_AT = "documentCondition";
export const CONST_SEND_MAIL_DOCUMENT_CONDITION_PARAMS_AT = "documentConditionParams";
export const CONST_SEND_MAIL_SEND_POSTPONE_AT = "sendPostpone";
export const CONST_SEND_MAIL_RECIPIENT_TYPE_AT = "recipientType";
export const CONST_SEND_SMS_EL = "SendSMS";
export const CONST_SEND_SMS_RECIPIENT_TYPE_AT = "recipientType";
export const CONST_SEND_SMS_RECIPIENT_AT = "recipient";
export const CONST_SEND_SMS_TEXT_AT = "text";
export const CONST_SEND_SMS_CLASS_NAME_AT = "className";
export const CONST_SEND_SMS_ATTR_NAME_AT = "attrName";
export const CONST_SEND_SMS_DATA_CONDITION_AT = "dataCondition";
export const CONST_SEND_WF_MESSAGE_EL = "SendWFMessage";
export const CONST_SEND_WF_MESSAGE_MESSAGE_NAME_AT = "messageName";
export const CONST_SEND_WF_MESSAGE_TARGET_OBJECT_NAME_AT = "targetObjectName";
export const CONST_SEND_WF_MESSAGE_OBJECTS_CONDITION_AT = "objectsCondition";
export const CONST_SEND_WF_MESSAGE_OBJECTS_CONDITION_PARAMS_AT = "objectsConditionParams";
export const CONST_SEND_WF_MESSAGE_AFTER_SAVE_AT = "afterSave";
export const CONST_SET_ATTRIBUTE_EL = "SetAttribute";
export const CONST_SET_ATTRIBUTE_VALUE_EL = "Value";
export const CONST_SET_ATTRIBUTE_VALUE_TYPE = "valueType";
export const CONST_SET_ATTRIBUTE_ATTR_NAME_AT = "attrName";
export const CONST_SET_OBJECT_ATTRIBUTE_EL = "SetObjectAttribute";
export const CONST_SET_OBJECT_ATTRIBUTE_VALUE_EL = "Value";
export const CONST_SET_OBJECT_ATTRIBUTE_ATTR_NAME_AT = "attrName";
export const CONST_SET_OBJECT_ATTRIBUTE_MASTER_CLASS_NAME_AT = "masterClassName";
export const CONST_SET_OBJECT_ATTRIBUTE_MASTER_ATTR_NAME_AT = "masterAttrName";
export const CONST_SET_VALUE_EL = "SetValue";
export const CONST_SET_VALUE_VALUE_EL = "Value";
export const CONST_SET_VALUE_NAME_AT = "name";
export const CONST_OPEN_FORM_FORM_TYPE_AT = "formType";
export const CONST_OPEN_FORM_FORM_CLASS_AT = "formClass";
export const CONST_OPEN_FORM_FORM_CONDITION_AT = "formCondition";
export const CONST_OPEN_FORM_REPORT_NAME_AT = "reportName";
export const CONST_OPEN_FORM_MASTER_LINK_TO_ATTR_AT = "masterLinkToAttr";

/** Participants konstanty */
export const CONST_PARTICIPANTS_EL = "Participants";
export const CONST_PARTICIPANT_EL = "Participant";
export const CONST_DEFINITION_PARTICIPANTS_EL = "DefinitionParticipants";
export const CONST_ROLE_EL = "Role";
export const CONST_ROLE_NAME_AT = "name";
export const CONST_ROLE_DB_ID_AT = "dbID";
export const CONST_DEFINITION_PARTICIPANT_EL = "DefinitionParticipant";
export const CONST_DEFINITION_PARTICIPANT_NAME_AT = "name";
export const CONST_DEFINITION_PARTICIPANT_CONDITION_AT = "condition";
export const CONST_DEFINITION_PARTICIPANT_ROLE_NAME_AT = "roleName";
export const CONST_SYSTEM_EL = "System";
export const CONST_USER_EL = "User";
export const CONST_USER_NAME_AT = "name";
export const CONST_USER_DB_ID_AT = "dbID";
export const CONST_OWNER_EL = "Owner";

/** Position konstanty */
export const CONST_POSITION_EL = "Position";
export const CONST_POSITION_X_AT = "x";
export const CONST_POSITION_Y_AT = "y";
export const CONST_POSITION_WIDTH_AT = "width";
export const CONST_POSITION_HEIGHT_AT = "height";
export const CONST_POSITION_SET_AT = "set";

/** Triggers konstanty */
export const CONST_TRIGGERS_EL = "Triggers";
export const CONST_TRIGGER_EL = "Trigger";
export const CONST_ATTRIBUTE_DATA_CHANGE_EL = "AttributeDataChange";
export const CONST_ATTRIBUTE_DATA_CHANGE_ATTR_NAME_AT = "attrName";
export const CONST_ATTRIBUTE_DATA_CHANGE_CONDITION_AT = "condition";
export const CONST_MENU_EL = "Menu";
export const CONST_MENU_TEXT_EL = "Text";
export const CONST_MENU_IDENTIFIER_AT = "identifier";
export const CONST_MENU_LANG_AT = "lang";
export const CONST_MENU_TEXT_AT = "text";
export const CONST_MENU_CODE_NAME = "codename";
export const CONST_MENU_ICON_NAME = "iconName";
export const CONST_MENU_PARTICIPANTS_SELECTING_AT = "participantsSelecting";
export const CONST_MENU_MULTI_ACTION_ENABLE_AT = "multiActionEnable";
export const CONST_MENU_VALIDATE_POST_REQ_AT = "validatePostReq";
export const CONST_MENU_VALIDATE_RECOMMENDED_AT = "validateRecommended";
export const CONST_MENU_CHOOSE_FROM_USERS_DEFAULT = "chooseFromUsersDefault";
export const CONST_MENU_MASTER_NODE_AT = "masterNode";
export const CONST_MENU_PARAM_FORM_NAME_AT = "paramFormName";
export const CONST_MENU_LINK_ATTR_FOR_SEL_OBJ_AT = "linkAttrForSelObj";
export const CONST_MENU_SET_VALUES_AT = "setValues";
export const CONST_MENU_CAPTIONS_EL = "Captions";
export const CONST_MENU_CONFIRM_MESSAGES_EL = "ConfirmMessages";
export const CONST_NEW_OBJECT_EL = "NewObject";
export const CONST_WFMESSAGE_EL = "WFMessage";
export const CONST_WFMESSAGE_MESSAGE_NAME_AT = "messageName";
export const CONST_WFMESSAGE_DEACTIVATING_AT = "deactivating";
